import { h, Fragment } from "preact";
import { Button, Divider, Tag } from "antd";
import { getCognitoStatusIcon, getCognitoStatusType, getQualifiedCognitoStatusName } from "./MembersUtils";


export default function MembersDataSource(members) {

    function asTableView(options) {

        const onEdit = (username, email, role) => {
            if (typeof options.onEdit === "function") {
                options.onEdit.call(this, username, email, role);
            }
        }

        const onDelete = (username) => {
            if (typeof options.onDelete === "function") {
                options.onDelete.call(this, username);
            }
        }

        return {
            columns: [
                { title: "Username", dataIndex: "username" },
                { title: "Email Address", dataIndex: "email" },
                { title: "Role", dataIndex: "role" },
                { title: "Status", dataIndex: "status" },
                { title: "Action", dataIndex: "action", align: "center" }
            ],
            rows: (members || []).map(({ username, email, status, role }, index) => ({
                key: index, username: username, email: email, role: role,
                status: (
                    <>
                        <Tag
                            icon={getCognitoStatusIcon(status)}
                            color={getCognitoStatusType(status)}
                        >
                            {getQualifiedCognitoStatusName(status)}
                        </Tag>
                    </>
                ),
                action: (
                    <>
                        <Button
                            type="link"
                            disabled={options.disabled || role === "admin"}
                            onClick={(_) => onEdit(username, email, role)}
                        >
                            Edit
                        </Button>
                        <Divider type="vertical" />
                        <Button
                            type="link"
                            disabled={options.disabled || role === "admin"}
                            onClick={(_) => onDelete(username)}
                        >
                            Delete
                        </Button>
                    </>
                )
            }))
        };
    }

    return { asTableView };
}